import { Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Atribute, MapConfirmationDto, PotentialCustomer } from './model/potential-customer';
import { SesionService } from 'src/app/core/service/sesion.service';
import { PotentialCustomerService } from './service/potential-customer.service';
import { LocationInfo } from 'src/app/shared/model/locatation-intefarce';
import { MapModel } from 'src/app/shared/components/molecules/map/model/map-model';
import { ShadowScrollService } from 'src/app/core/service/utils/shadow-scroll.service';
import { MatDialog } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { noEmojisValidator } from 'src/app/core/service/utils/regex-list.regex';
import { MapComponent } from 'src/app/shared/components/molecules/map/map.component';

@Component({
  selector: 'app-potential-customer',
  templateUrl: './potential-customer.component.html',
  styleUrls: ['./potential-customer.component.scss'],
})
export class PotentialCustomerComponent implements OnInit {
  @ViewChild('mapRef') mapRef!: MapComponent;
  customerForm: FormGroup;
  submitted: boolean;
  loading: boolean;
  sesionData: PotentialCustomer | null;
  phase: number = 1;
  isMobile: boolean;

  @Output()
  onComplete = new EventEmitter<number>();

  constructor(
    private readonly fb: FormBuilder,
    private readonly sesion: SesionService,
    public dialog: MatDialog,
    private readonly service: PotentialCustomerService,
    public shadowScroll: ShadowScrollService,
    private readonly deviceService: DeviceDetectorService,
  ) {
    this.submitted = false;
    this.loading = false;

    this.sesionData = this.sesion.getItem('potential_customer');
    this.customerForm = this.fb.group({
      location: [this.sesionData ? this.sesionData.location : '', [Validators.required,noEmojisValidator]],
      fantasyName: [
        this.sesionData ? this.sesionData.fantasyName : '',
        [Validators.required, Validators.maxLength(40),noEmojisValidator],
      ],
    });
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit(): void {
    setTimeout(() => {}, 1500);
  }

  onSubmit() {
    if (!this.loading) {
      // Forzar evaluación sincrónica del mapa antes de verificar validez del form
      // Esto cierra el gap del debounceTime que podría dejar datos obsoletos en el CVA
      if (this.mapRef) {
        this.mapRef.validate();
      }
      this.submitted = true;
      let data = this.createPotentialCustomerDTO();
      console.log('data', data);
      if (this.customerForm.valid) {
        let locationInfo = this.getInfoLocation(data.location);
        let province = data.location.state.toLocaleUpperCase();
        if(province.includes('PROVINCE')){
          province = province.replace(" PROVINCE", "");
        }
        data.location.state = province;
      // const dialog = this.dialog.open(MapConfirmComponent, {
      //   width: '100vh',
      //   disableClose: false,
      //   data: {
      //     coordinates: data.location.coordinates,
      //     address: data.location.street,
      //     streetNumber: data.location.streetNumber,
      //   },
      // });
      // dialog.afterClosed().subscribe((mapConfirmResponse: MapConfirmationDto) => {
      //   if(mapConfirmResponse){
      //     data.location.streetNumber = mapConfirmResponse.noneNumber? 0 : mapConfirmResponse.streetNumber;
      //     data.location.street = mapConfirmResponse.street;
      //     data.location.coordinates = mapConfirmResponse.coordinates;
      //     console.log('nuevos datos:', data);
      //     this.sesion.setItem<PotentialCustomer>('potential_customer', data);
      //     this.service.validateCP(locationInfo).subscribe((data) => {
      //       this.sesion.setItem<Atribute[]>('atribute', data);
      //     });
      //     this.formComplete();
      //   }
      // });
          this.sesion.setItem<PotentialCustomer>('potential_customer', data);
          this.service.validateCP(locationInfo).subscribe((data) => {
            this.sesion.setItem<Atribute[]>('atribute', data);
          });
          this.formComplete();

    }
    }
  }

  formComplete() {
    this.onComplete.emit(2);
  }

  getInfoLocation(locationData: MapModel): LocationInfo {
    let infoLocation: LocationInfo = {
      city: locationData.city,
      state: locationData.state,
      zipCode: locationData.postCode,
    };
    return infoLocation;
  }

  createPotentialCustomerDTO(): PotentialCustomer {
    let data: PotentialCustomer = {
      location: this.customerForm.controls['location'].value,
      fantasyName: this.customerForm.controls['fantasyName'].value,
    };
    return data;
  }

  @HostListener('scroll', ['$event'])
  onScroll(e: any) {
    this.shadowScroll.scroll(e);
  }
}
